import React from "react";
import "./Sidebar.scss";
import { SVG } from "sunrise-ui";
import { NavLink } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import { useLocation } from "react-router-dom";

interface AuxProps {
  children: React.ReactNode;
}

const Sidebar = ({ children }: AuxProps) => {
  const location = useLocation();
  const menuItem = [
    {
      name: "Dashboard",
      path: "/dashboard",
      icon: "dashboard",
    },
    {
      name: "Projects",
      path: "/projects",
      icon: "project",
    },
    {
      name: "Reports",
      path: "/reports",
      icon: "report",
    },
    {
      name: "Users",
      path: "/users",
      icon: "users",
    },
    {
      name: "Machine and its Logs",
      path: "/machine",
      icon: "machine",
    },
    {
      name: "Inventory",
      path: "/inventory",
      icon: "inventoryModuleIcon",
    },
    {
      name: "Bills",
      path: "/bills",
      icon: "bills",
    },
    {
      name: "Master Config",
      path: "/master",
      icon: "masterConfig",
    },
    {
      name: "Attendance",
      path: "/attendance",
      icon: "report",
    },
    {
      name: "Profile",
      path: "/profile",
      icon: "dashboardProfile",
    },
  ];
  return (
    <div className="sidebar_main_container">
      <div className="sidebar">
        <div className="top d-flex h-center v-center">
          <SVG type="title" />
        </div>
        <div className="middle d-flex h-center">
          <div className="link_container">
            <ul>
              {menuItem?.map((item: any, index: number) => (
                <NavLink to={item.path} className="link" key={index}>
                  <li
                    className={
                      location.pathname === item?.path ||
                      (location.pathname === "/change_password" &&
                        item?.path === "/profile")
                        ? "active"
                        : ""
                    }
                  >
                    <span>
                      <SVG
                        type={item.icon}
                        isActive={
                          location.pathname === item?.path ||
                          (location.pathname === "/change_password" &&
                            item?.path === "/profile")
                            ? true
                            : false
                        }
                      />
                    </span>
                    <span>{item.name}</span>
                  </li>
                </NavLink>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <main className="content_container">
        <div className="nav_box pr">
          <Navbar />
        </div>
        {children}
      </main>
    </div>
  );
};

export default Sidebar;
